import { useMemo } from 'react'

export type ProductEnv = 'marketplace' | 'enterprise'

export interface FeatureFlags {
  allowUserRegistration: boolean
  enableEmployeeUser: boolean
  enablePasskey: boolean
}

// REACT_APP_ENABLE_PASSKEY=true enables passkeys; any other value (or absence) disables them.
// Defaults to false when the variable is not set.
const passkeyEnabled = process.env.REACT_APP_ENABLE_PASSKEY === 'true'

const featuresByProduct: Record<ProductEnv, FeatureFlags> = {
  marketplace: {
    allowUserRegistration: true,
    enableEmployeeUser: false,
    enablePasskey: passkeyEnabled,
  },
  enterprise: {
    allowUserRegistration: false,
    enableEmployeeUser: true,
    enablePasskey: passkeyEnabled,
  },
}

const productEnv = (process.env.REACT_APP_PRODUCT_ENV || 'enterprise') as ProductEnv

export const features: FeatureFlags = featuresByProduct[productEnv]
export const currentProduct = productEnv

export const useFeatureFlag = (feature: keyof FeatureFlags): boolean => {
  return useMemo(() => features[feature], [feature])
}



